import React, {useState} from "react";
import {Button, Table, Typography, Divider} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {MODAl_REDUCER} from "../../reducers/modal.reducer";
import {MENU_REDUCER} from "../../reducers/menu.reducer";
import {isAbleToDelete} from "../../ui-util/general-variable";
import {Styles} from "../../ui-util/styles";
import {Colors} from "../../ui-util/colors";

const {Text} = Typography;

const MenuList = () => {
    const dispatch = useDispatch();
    const {menuList, menuLoading} = useSelector(state => state.menuReducer)
    const {searchKey} = useSelector(state => state.analyticsReducer)
    const [columns] = useState([
        {
            dataIndex: 'name', title: 'Name',width: 50,
            render: name => <div style={Styles.fontArmyGrayBold}>{name}</div>
        }, {
            dataIndex: 'mainmenu', title: 'Main Menu',width: 150,
            render: mainmenu => <div style={{color: Colors.armyGray}}>{mainmenu.name}</div>
        },  {
            dataIndex: 'slug', title: 'Slug',width: 150,
            render: (slug) => <div style={{color: Colors.darkGrey}}>{slug}</div>
        },  {
            dataIndex: 'url', title: 'Url', width: 400,
            render: (url) => <Text style={{wordWrap: 'break-word', wordBreak: 'break-word', color: Colors.darkGrey}}>{url}</Text>
        }, {
            title: 'Action', width: 250,
            render: (record) => {
                return (
                    <>
                        <Button onClick={() => {
                            dispatch({type: MODAl_REDUCER, payload: {modalVisibility: true, modalTitle: 'Update menu'}})
                            dispatch({type: MENU_REDUCER, payload: {menuDetail: record}})
                        }} style={Styles.buttonUpdateDelete}>
                            <div style={Styles.fontArmyGrayBold}>Update</div>
                        </Button>
                        <Divider type="vertical" />
                        {
                            isAbleToDelete(record.slug) &&
                            <Button onClick={() => {
                                dispatch({type: MODAl_REDUCER, payload: {modalVisibility: true, modalTitle: 'Delete menu'}})
                                dispatch({type: MENU_REDUCER, payload: {menuDetail: record}})
                            }} style={{borderRadius: 12}}>
                                <div style={Styles.fontArmyGrayBold}>Delete</div>
                            </Button>
                        }
                    </>
                )
            }
        },
    ])

    const filteredData = () => {
        let dataFiltered = []
        menuList.forEach(item => {
            if(item.name.toLowerCase().includes(searchKey.toLowerCase())){
                dataFiltered.push(item)
            }
        })

        return dataFiltered
    }

    return (
        <Table
            columns={columns}
            dataSource={filteredData()}
            rowKey={record => record.id}
            loading={menuLoading}
        />
    )
}

export default MenuList
